import * as Logger from '../../common/tools/logger';
import { CommunicationHandlerService } from '../tools/communication-handler.service';
import { CONFIG_VERSION } from '../../config';

/**
 * Provides the business logic as a CMP (Consent Management Platform) to handle and process users permission data
 */
export class PermissionCoreApp {

  public version = CONFIG_VERSION;
  private moduleName = `PermissionCoreApp`;
  private communicationHandlerService: CommunicationHandlerService = new CommunicationHandlerService();
  private initPromise: Promise<void>;

  constructor() {
    try {
      this.initPromise = this.communicationHandlerService.initialize()
        .catch((error) => {
          this.communicationHandlerService.closePermissionLayer();
          Logger.error(this.moduleName, `init`, error);
        });

      Logger.debug(this.moduleName, `init`, `Module initialized.`);
    } catch (error) {
      this.communicationHandlerService.closePermissionLayer();
      Logger.error(this.moduleName, `init`, error);
    }
  }

}
